import { isNumber } from './typeHelpers';

export function isObject(item: unknown) {
    return (item && typeof item === 'object' && !Array.isArray(item));
}

/** 
 * Filter out un-truthy values of the Object 
 * 
 *  @param {boolean} stringify - Enables stringification. __Currently only supports stringify'ing numbers__
 * */
export const filterObject = <T extends object, S extends boolean>(obj: T, stringify?: S) => {
    for (const key in obj) {
        const value = obj[key];
        if (stringify && isNumber(value)) (obj as any)[key] = value.toString();
        if (!value) delete obj[key];
    }

    return obj as S extends true ? { [K in keyof T]: string } : T;
};

/**Returns a deep copy of the object or the array that includes data only. Include properties that are supported by JSON */
export const cloneData = <T extends {} | []>(target: T) => {
    if (!target) return target;
    return JSON.parse(JSON.stringify(target)) as T;
};

export const deepMergeData = (target: any, ...sources: any[]): any => {
    return cloneData(deepMerge(target, ...sources));
};

export const deepMerge = (target: any, ...sources: any[]): any => {
    if (!sources.length) return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, { [key]: {} });
                deepMerge(target[key], source[key]);
            } else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }

    return deepMerge(target, ...sources);
};



export const wrapAsMdJson = (content: any) => {
    let text = JSON.stringify(content, null, 4);
    let format = "json";
    // If the payload contains more than 300k charts, we will avoid rendering it as json and truncate it
    // This is done to avoid crashing the browser.
    const limit = 3e5;
    if (text.length > limit) {
        format = "";
        text = text.substring(0, limit) + "\n...";
    }
    return ["```" + format, text, "```"].join('\n');
};


export const hashObject = (obj: any): string => {
    const str = JSON.stringify(obj);
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash.toString(16); // hex string
};